import { useState } from 'react';
import { Box } from '@chakra-ui/react';
import AutoformTableContainer from './AutoformTableContainer';
import useAutoformMetadata from './hooks/useAutoformMetadata';
import Level1AutoformHeader from './Level1AutoformHeader';

const Level1Autoform = () => {
    const { metadata, hierarchicalTables } = useAutoformMetadata();
    // eslint-disable-next-line no-unused-vars
    const [search, setSearch] = useState('');

    if (!metadata) return 'Loading...';
    if (!hierarchicalTables.level1.length === 0) return 'Loading...'; //TODO: Validation of autoform levle 1x
    return (
        <>
            <Level1AutoformHeader onChange={setSearch} itemDescription={metadata.description} />
            <Box px={6} pt={6}>
                <AutoformTableContainer
                    schemaCode={metadata.schemaCode}
                    tableId={hierarchicalTables.level1[0]?.id}
                    searchString={search}
                />
            </Box>
        </>
    );
};

export default Level1Autoform;
